import { Routes, Route } from 'react-router-dom';
import SignaturePage from './pages/SignaturePage';
import LinkRedirect from './pages/LinkRedirect';
import SuccessPage from './pages/SuccessPage';
import ErrorPage from './pages/ErrorPage';
import NotFoundPage from './pages/NotFoundPage';
import VerifyPage from './pages/VerifyPage';
import VerifyResultPage from './pages/VerifyResultPage';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/s/:token" element={<SignaturePage />} />
        <Route path="/l/:code" element={<LinkRedirect />} />
        <Route path="/sign/:token" element={<SignaturePage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/verify/:documentId" element={<VerifyResultPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
